import PropTypes from 'prop-types';
import { useFormContext, Controller, useController } from 'react-hook-form';
import { FormControl, Box } from '@mui/material';
// @mui
import FormHelperText from '@mui/material/FormHelperText';
//
import { Editor } from '@tinymce/tinymce-react';
import { useRef } from 'react';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingScreen } from '../loading-screen';

// ----------------------------------------------------------------------

export default function RHFTinyEditor({ name, id, helperText, ...other }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const {
    field: { onChange, value, onBlur, disabled },
    fieldState: { invalid },
  } = useController({ control, name });

  const isLoading = useBoolean(true);
  const textFieldRef = useRef(null);

  return (
    <Box sx={{ position: 'relative' }}>
      {isLoading.value && (
        <LoadingScreen
          sx={{
            position: 'absolute',
            zIndex: 9999,
            background: theme => theme.palette.background.primaryWhite1,
            height: '100%',
          }}
          isLoading={isLoading.value}
        />
      )}
      <Editor
        id={id}
        tinymceScriptSrc='/tinymce/js/tinymce/tinymce.min.js'
        onInit={(evt, editor) => {
          isLoading.onFalse();
          textFieldRef.current = editor;
        }}
        value={value}
        disabled={disabled}
        onBlur={onBlur}
        init={{
          height: 300,
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
        onEditorChange={onChange}
        {...other}
      />
      {invalid && errors[name] && (
        <FormHelperText error>{errors[name].message}</FormHelperText>
      )}
    </Box>
  );
}

RHFTinyEditor.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
};
